export default __webpack_public_path__ + "images/WD.27b6cba.png";